export default {
  productDetail: {
    GroupPrice: 'Group Price',
    GroupPeople: 'Group People',
    Joined: 'Joined',
    Items: 'Items',
    InitiatedGroup: 'Initiated Group',
    ViewAll: 'View All',
    Remaining: 'Remaining',
    OnlyLeft: 'Only Left',
    GoToGroupOrder: 'Go to Group Order',
    GroupProcess: 'Group Process',
    ActivityRules: 'Activity Rules',
    GroupLeader: 'Organizer',
    InviteFriends: 'Invite Friends',
    GroupSuccess: 'Group Success',
    WaitingForShipment: 'Waiting for Shipment',
    DeliveredTo: 'Delivered to',
    SelectShippingAddress: 'Select Shipping Address',
    ShippingFee: 'Shipping Fee',
    ProductDetails: 'Product Details',
    NoMoreContent: 'No more content',
    Restocking: 'Restocking',
    StartingFrom: 'Starting from',
    BuySeparately: 'Buy Separately',
    InitiateGroupOrder: 'Initiate Group Order',
    JoinGroupBuying: 'Join Group Buying',
    Remainings: 'Remaining',
    GroupBuyingInProgress: 'Group Buying In Progress',
    GroupBuyingExplanation1: '1. Users participate in group buying activities, become group buying organizer, and invite users to join. If the number of participants reaches the required number within the specified time, the group is successful and awaiting shipment.',
    GroupBuyingExplanation2: '2. If the number of participants does not reach the required number within the specified time after the group is initiated, or if the inventory is sold out before the group is completed, the group fails, and the order is automatically canceled with a full refund issued to the payment account.',
    GroupBuyingExplanation3: '3. Group buying purchases only support online payment and do not support cash on delivery.',
    GroupBuyingExplanation4: '4. Cancellation of orders: If a group buying order is not successfully paid and the group it participates in has either succeeded or failed, the group buying order is automatically canceled. Once a group buying order is successfully paid, it cannot be canceled. All orders in a failed group are automatically canceled.',
    GroupBuyingExplanation5: '5. For some highly popular and discounted products, there may be a limit on the number of group buying purchases. Please pay attention to the prompts. Any violations or participation in promotional activities through improper means may result in the cancellation of your participation and the nullification of related discounts.',
    GroupBuyingExplanation6: '6. In the FAFULI personal center - My Group Buying, you can view your group buying activities.',
    GroupBuyingExplanation7: '7. FAFULI reserves the right to interpret the rules of this activity within the scope permitted by law.',
    Quantity: 'Quantity',
    LimitQuantity: 'Limit Quantity',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    GroupBuyingEnded: 'Group Buying Ended',
    ExceededLimitQuantity: 'Exceeded Limit Quantity',
    SelectSpecification: 'Select Specification',
    ProductOutOfStock: 'Product Out of Stock',
    ActivityEnded: 'Activity Ended',
    Liked: 'Liked',
    GroupedAt: 'Grouped at',
    FriendRecommendation: 'Friend Recommendation'
  }
}
